import React, { useState, useContext, useEffect } from "react"
import { UserContext } from 'context/UserContext';
import { LoadingContext } from 'context/LoadingContext';
import axios from 'axios';
import toast from 'react-hot-toast';


export const VisaoGeral: React.FC = () => {
	const { usuarioLogado, competenciaSelecionada } = useContext(UserContext);
	const { isLoading, setLoading } = useContext(LoadingContext);
	const testToastr = () => toast('TEST');
	const testToastrSuccess = () => toast.success('TEST SUCESSO MSG RAZOÁVEL afds fasf dasf asfdas fdas fdasf ');
	const testToastrError = () => toast.error('TEST');

	const [condsAtivos, setCondsAtivos] = useState<Array<object>>([])


	useEffect(() => {
		const buscarCondAtivo = async () => {
			const response = await axios.get(`/api/condominio/ativos`);
			if(response && response.data) {
				setCondsAtivos(response.data);
			}
		}

		 buscarCondAtivo().catch(() => toast.error('Erro ao buscar os condsAtivos'));

	}, []);


	return (
		
		<div className="col-sm-12">			
			<div className="row">
				{usuarioLogado.nome} - 
				{competenciaSelecionada?.toISOString()}
			</div>
			<div className="row">
				<button className={"btn-primary"} onClick={testToastr}>TEST TOASTR</button>
			</div>
			<div className="row">
				<button className={"btn-primary"} onClick={testToastrSuccess}>TEST TOASTR SUCCESS</button>
			</div>
			<div className="row">
				<button onClick={testToastrError}>TEST TOASTR ERROR</button>
			</div>
			<div className="row">
				<button onClick={() => setLoading(true)}>TEST LOADING</button>
			</div>
		</div>
		
	)

}